(function () {
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  function wrapSplitLines(lines) {
    lines.forEach(function (line) {
      if (line.parentNode.classList && line.parentNode.classList.contains("croma-split-line-mask")) {
        return;
      }

      var wrapper = document.createElement("span");
      wrapper.className = "croma-split-line-mask";

      line.parentNode.insertBefore(wrapper, line);
      wrapper.appendChild(line);
    });
  }

  function initCromaHeadings() {
    if (typeof gsap === "undefined") return;
    if (typeof SplitText === "undefined") return;
    if (typeof ScrollTrigger === "undefined") return;

    gsap.registerPlugin(ScrollTrigger, SplitText);

    var headings = document.querySelectorAll(
    "main h1:not([data-croma-split-ready]), main h2:not([data-croma-split-ready])"
    );

    headings.forEach(function (heading) {
      heading.setAttribute("data-croma-split-ready", "true");

      var split = new SplitText(heading, {
        type: "lines",
        linesClass: "croma-split-line"
      });

      wrapSplitLines(split.lines);

      gsap.set(split.lines, {
        yPercent: 110,
        opacity: 0
      });

      gsap.to(split.lines, {
        yPercent: 0,
        opacity: 1,
        duration: 1,
        ease: "power3.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: heading,
          start: "top 85%",
          once: true
        }
      });
    });

    ScrollTrigger.refresh();
  }

  function debounce(fn, delay) {
    var timer;

    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  var refreshSplit = debounce(function () {
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
  }, 250);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCromaHeadings);
  } else {
    initCromaHeadings();
  }

  window.addEventListener("resize", refreshSplit);

  document.addEventListener("shopify:section:load", function () {
    initCromaHeadings();
  });
})();